import Image from 'next/image'
import React from 'react'

import CoastLogo from '../images/Coast_Logo.svg'

export const Logo = () => <Image src={CoastLogo} alt="Coast" style={{ height: 74, width: 'auto' }} priority />
